export default __webpack_public_path__ + "static/media/paymentIcon.f5ec841a.svg";